import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";
import type { MailboxInfo } from "owa-client-types";
import type { ResourceTokenAuthInfoBarRequest } from "owa-account-authstate-store";

export { hasAccountCriticalResourceAuthInfoBarRequest, hasResourceTokenAuthInfoBarRequest, } from "./eagerIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "ResourceTokenAuthInfoBar" */ "./lazyIndex"), { name: "ResourceTokenAuthInfoBar" });

export const ResourceTokenAuthInfoBarHost: LazyComponent<{
    mailboxInfo: MailboxInfo;
    onSignInSucceeded?: (request: ResourceTokenAuthInfoBarRequest) => void | Promise<void>;
}, unknown, void> = createLazyComponent(lazyModule, m => m.ResourceTokenAuthInfoBarHost);
